<script>
    import { fade } from 'svelte/transition';
    import InputField from "../InputField.svelte";
    import DateSearcher from "../../SearchBars/DateSearcher.svelte";
    import RadioButtons from "../../SearchBars/RadioButtons.svelte";
    import { isRootManager, isAdmin } from "../../../stores/settingsStore";

    export let membership;
    export let isUGS;
    export let errors;
    export let settings;
    export let handleChange;
    export let name;
    let isEditable = true;

    const activeMembershipOptions = [
        { value: true, label: "Attivo", id: "activeMembershipOption" },
        { value: false, label: "Non attivo", id: "inactiveMembershipOption" },
    ];

    const mapPaymentMethod = [
        { paymentMethod: "APPLE_PAY", label: "Apple Pay" },
        { paymentMethod: "PAYPAL", label: "PayPal" },
        { paymentMethod: "NUMIA", label: "Pagamento online" },
        { paymentMethod: "BANK", label: "Pagamento con bonifico bancario" },
    ];

    function getPaymentMethodLabel(mb) {
        return mapPaymentMethod.find((pm) => pm.paymentMethod === mb.paymentMethod)?.label ?? "Pagamento con bonifico bancario"
    }

    $: isPaymentInfoDisabled = !membership.active || !isEditable;
    $: isEditable = $isAdmin || $isRootManager;
</script>

<div class="w-full flex flex-col gap-3 md:flex-row">
    <div class="w-full md:w-1/2">
        <InputField
            fieldName="Anno di riferimento"
            value={membership.year}
            isDisabled={true}
        />
    </div>
    <div class="w-full md:w-1/2">
        <InputField
            fieldName="Numero tessera"
            value={membership.code ?? "Tessera non presente"}
            isDisabled={true}
        />
    </div>
</div>

<div class="w-full">
    <div class="font-450 text-lg">Stato tessera</div>

    <RadioButtons
        bind:inputValue={membership.active}
        disabled={!isEditable}
        isNullable={false}
        options={activeMembershipOptions}
    />
</div>

{#if membership.active }
    <InputField
        value={getPaymentMethodLabel(membership)}
        fieldName="Metodo di pagamento"
        isDisabled={true}
    />

    <div class="w-full flex flex-col gap-3 md:flex-row">
        <div class="w-full md:w-1/2">
            <DateSearcher
                bind:value={membership.paidAt}
                errorText={errors?.paidAt ?? ''}
                isDisabled={!isEditable}
                fieldName="Data pagamento"
                handleChange={handleChange}
                name={name + ".paidAt"}
                placeholder="Inserisci la data del pagamento"
            />
        </div>

        <div class="w-full md:w-1/2">
            <div class="h-full relative">
                <InputField
                    bind:value={membership.paidAmount}
                    bind:isDisabled={isPaymentInfoDisabled}
                    handleChange={handleChange}
                    fieldName="Quota"
                    name={name + ".paidAmount"}
                    placeholder="Inserisci la somma pagata"
                    type="number"
                    errorText={errors?.paidAmount ?? ''}
                />

                <i transition:fade={{duration: 100}} class="absolute font-450" style="right: 35px; top: 35px">€</i>
            </div>
        </div>
    </div>

    <InputField
        fieldName="ID della transazione del gestionale"
        value={membership.shopId}
        isDisabled={true}
    />

    <div class="flex flex-col md:flex-row gap-3">
        <InputField
            fieldName="ID della transazione"
            value={membership.tranId}
            isDisabled={true}
        />

        <InputField
            fieldName="ID del pagamento"
            value={membership.paymentId}
            isDisabled={true}
        />
    </div>
{/if}

<style>
     input::-webkit-outer-spin-button,
     input::-webkit-inner-spin-button {
         -webkit-appearance: none;
         margin: 0;
     }

    input[type=number] {
        -moz-appearance: textfield;
    }
</style>

